import { SET_ACTIVE_ITEM } from './constants';
import { CLEAR_STATE } from '../HandleAPICalls/constants';

const initialState = {
  activeItem: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ACTIVE_ITEM:
      return {
        ...state,
        activeItem: action.activeItem,
      };

    case CLEAR_STATE:
      return initialState;

    default: return state;
  }
};



// WEBPACK FOOTER //
// ./src/Modules/Navigation/reducer.js